import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { newTemplateComponent } from './newTemplate.component';


import { DocumentsDetailModule } from './../components/documentsDetail.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { TableModule } from 'primeng-lts/table';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { DropdownModule } from 'primeng-lts/dropdown';
import { InputTextModule } from 'primeng-lts/inputtext';
import { ListboxModule } from 'primeng-lts/listbox';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { TreeModule } from 'primeng-lts/tree';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';

@NgModule({
  declarations: [newTemplateComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    DocumentsDetailModule,
    WaitLoadingModule,
    DropdownModule,
    FormPlycaModule,
    TreeModule,
    InputTextModule,
    ListboxModule,
    TableModule,
    OverlayPanelModule,
    SubHeaderModule,
    TreeModule,
    ScrollPanelModule
  ]
})
export class NewTemplateModule { }
